import type { Environment } from '../app/core/tokens/app.tokens';
import { environmentDefaults } from './environment.defaults';

export const environment: Environment = {
  ...environmentDefaults,
  production: false,
};
